import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Button from '../ui/Button';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiMail, FiCheck } = FiIcons;

const NewsletterSignup = ({ className = '' }) => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // idle, success

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Newsletter signup:', email);
    setStatus('success');
    setEmail('');
    
    // Reset after 3 seconds
    setTimeout(() => {
      setStatus('idle');
    }, 3000);
  };

  return (
    <div className={`bg-primary-50 rounded-lg p-6 ${className}`}>
      <div className="text-center mb-4">
        <SafeIcon icon={FiMail} className="w-8 h-8 text-primary-600 mx-auto mb-2" />
        <h3 className="text-lg font-semibold text-neutral-900 mb-2">
          Stay Connected
        </h3>
        <p className="text-neutral-600">
          Get updates on outreach events, testimonies, and ways to get involved.
        </p>
      </div>

      <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3 relative">
        <AnimatePresence mode="wait">
          {status === 'success' ? (
            <motion.div 
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              className="w-full bg-green-100 text-green-700 px-4 py-2 rounded-lg flex items-center justify-center border border-green-200"
            >
              <SafeIcon icon={FiCheck} className="w-5 h-5 mr-2" />
              <span className="font-medium">Subscribed successfully!</span>
            </motion.div>
          ) : (
            <motion.div 
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              className="flex flex-col sm:flex-row gap-3 w-full"
            >
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                required
                className="flex-1 px-4 py-2 border border-neutral-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent"
              />
              <Button type="submit" variant="primary">
                Subscribe
              </Button>
            </motion.div>
          )}
        </AnimatePresence>
      </form>
    </div>
  );
};

export default NewsletterSignup;